import { Box, Heading, Paragraph, Spacer, Spinner } from '@zillow/constellation';
import { Wizard } from '@zillow/zrs-rental-applications';
import React from 'react';

export default function ListingWizardStep({ icon, title, description, render, isLoading, ...rest }) {
  const descriptions = Array.isArray(description) ? description : [description];
  return (
    <Wizard.Step
      {...rest}
      render={(renderProps) =>
        isLoading ? (
          <Spinner size="lg" />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              maxWidth: '400px',
              marginBottom: '$spacing.md',
            }}
          >
            <Spacer marginBottom="md">{icon}</Spacer>
            <Heading level={5} as="h1" marginBottom="md">
              {title}
            </Heading>
            {descriptions.map((desc) => (
              <Paragraph key={desc} marginBottom="md">
                {desc}
              </Paragraph>
            ))}
            <Box
              sx={{
                alignSelf: 'stretch',
              }}
            >
              {render(renderProps)}
            </Box>
          </Box>
        )
      }
    />
  );
}
